import { LoadSurgicalOrderTimeLine } from 'domain/usecases/surgical-pendency/load-surgical-order-time-line'
import { SurgicalPendencyRepository } from 'repository/interfaces/surgical-pendency-repository'

export class RemoteLoadSurgicalOrderTimeLine
  implements LoadSurgicalOrderTimeLine
{
  constructor(
    private readonly surgicalPendencyRepository: SurgicalPendencyRepository
  ) {}
  load(surgical_order_id: number): Promise<LoadSurgicalOrderTimeLine.Model> {
    return this.surgicalPendencyRepository.loadSurgicalOrderTimeLine(
      surgical_order_id
    )
  }
}
